import { render, staticRenderFns } from "./TransportColorInput.vue?vue&type=template&id=5ad01ea2"
import script from "./TransportColorInput.vue?vue&type=script&lang=js"
export * from "./TransportColorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports